module.exports = __webpack_public_path__ + "media/react/components/FavouritePlans/SavedSequence/assets/ico-lower-7a289272f18ba50efe6c37e48a7f23e6.svg";